import { ReactNode, useContext } from "react";
import { Navigate } from "react-router";
import { AppCtx } from "../../provider/AppContext";

interface UnprotectedRouteProps {
    children: ReactNode;
}

function UnprotectedRoute({ children }: UnprotectedRouteProps) {
    const appContex = useContext(AppCtx);

    if (appContex.isLogged)
        return <Navigate to="/home" replace />;

    return <>{children}</>;
}

export default UnprotectedRoute;
